import React from 'react';

/*** images ***/
import imgSrcLogo from '../../image/logo.png';
import imgSrcWhitePhone from '../../image/white-phone-32.png'

export const Header = () => {
    return(
        <header>
            <div className={"header__phone_number"}>
                <img src={imgSrcWhitePhone} alt="Manhart"/>
                <a href="tel:+41 081 733 11 36" className={"header__number"}>+ 41 081 733 11 36</a>
            </div>
            <div className="img-logo">
                <img src={imgSrcLogo} alt="Manhart" className={"header__logo"}/>
            </div>
        </header>
    )
};


// WEBPACK FOOTER //
// ./src/components/Header/Header.js